export default __webpack_public_path__ + "meh-face-emoticon.png";